import { styled } from '@mui/material/styles';
import { Paper, TextField, IconButton } from '@mui/material';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2px 4px',
  boxShadow: 'none',
  borderTop: `1px solid ${theme.palette.divider}`,
  borderRadius: 0,
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  flex: 1,
  maxWidth: '600px',
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius,
  },
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  whiteSpace: 'pre-wrap',
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: 10,
  marginLeft: theme.spacing(1),
}));
